// Seeded into the generation params before the models catalog loads. Free users
// stay on the non-premium default; paid users are bumped to the premium default
// once we know the model supports it (see avatarModels reconciliation).
export const AVATAR_DEFAULT_QUALITY = 480
export const AVATAR_PAID_DEFAULT_QUALITY = 720

// Speech script length limits (chars). The free limit is enforced by the
// backend; the textarea, the landing handoff, and the generate boundary all
// clamp to it.
export const SPEECH_FREE_MAX_LENGTH = 150
export const SPEECH_MAX_LENGTH = 2000
// AI image model backing the source-image ENHANCE operation only (Resize uses
// the gpt resize-default model — see `getResizeImageModel`). The cost badge
// reads the matching model out of the fetched aiImage models list
// (`getSourceImageModel`); if the code is absent from the catalog the UI
// degrades gracefully (cost 0, fallback aspect ratio).
export const AVATAR_SOURCE_IMAGE_MODEL_CODE = 'gpt-image-2'

// Expected wall-clock for a source-image Enhance/Resize, feeding the SIMULATED
// progress ticker (generationProgressService) behind the preview's percentage
// ring — there is no real progress signal from the backend. The ticker ramps
// toward 99% on this schedule and stalls there until the socket completes it,
// so a too-small value means a long visible stall at 99%. Slightly above the
// AI Image tab's 10s: these ops run a heavier edit/reframe pass.
export const AVATAR_SOURCE_IMAGE_EXPECTED_DURATION_SECONDS = 20

// Ratios excluded from the Resize menu even when the resize model supports
// them: 'auto' is a generation choice, not a resize target (reco's
// /gen-ai/resize-image validator filters it out too).
export const AVATAR_RESIZE_EXCLUDED_ASPECT_RATIOS = ['auto', '21:9']

// Prompt for the "Enhance quality" op: improves clarity AND reframes the
// subject into a front-facing head-and-shoulders talking-head composition,
// while locking the person's identity (same face/features/hair/clothing) so
// the result stays a faithful reference. Template literal — one line per
// section, sent as-is (single newlines, no blank lines).
export const AVATAR_ENHANCE_PROMPT = `Enhance and reframe this portrait for use as a high-fidelity AI avatar reference photo.
REFRAMING / POSE: Reposition the subject into a standard avatar-video composition — front-facing, head-on to the camera, head and upper shoulders centered in frame, eyes level and looking directly into the lens. Crop to a clean head-and-shoulders framing suitable for talking-head avatar generation.
IDENTITY LOCK (preserve exactly): This must remain the same person. Do not alter facial structure, identity, features, expression, hairstyle, skin tone, age, or body type. Do not add or remove makeup, jewelry, glasses, facial hair, or clothing not present in the original. Only the pose and framing relative to the camera may change.
QUALITY: Increase resolution and sharpness, correct exposure and white balance, reduce noise and compression artifacts. Sharpen facial detail (eyes, eyebrows, hairline, skin texture) while preserving natural skin texture — do not smooth, retouch, beautify, or airbrush.
BACKGROUND: Keep the original background, cleaned and denoised. If reframing exposes empty area, extend the existing background naturally rather than inventing a new scene.
OUTPUT: Photorealistic, natural studio-quality lighting, 4K detail.`
